"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.error"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.loading"));

var _moize = _interopRequireDefault(require("moize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StoreSync =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StoreSync, _React$Component);

  function StoreSync() {
    var _this;

    _classCallCheck(this, StoreSync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StoreSync).call(this));
    _this.memoStores = _moize["default"].deep(function (stores) {
      return _this.load(stores);
    });
    _this.requests = {};
    return _this;
  }

  _createClass(StoreSync, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$memoStores = this.memoStores(this.props.stores),
          shouldFetch = _this$memoStores.shouldFetch;

      if (shouldFetch) {
        this.fetchAll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var fetchMap = this.props.fetchMap;

      var _this$memoStores2 = this.memoStores(prevProps.stores),
          prevShouldFetch = _this$memoStores2.shouldFetch;

      var _this$memoStores3 = this.memoStores(this.props.stores),
          shouldFetch = _this$memoStores3.shouldFetch;

      if (shouldFetch && !prevShouldFetch && fetchMap) {
        this.fetchAll();
      }
    }
  }, {
    key: "fetchAll",
    value: function fetchAll() {
      var _this$props = this.props,
          fetchMap = _this$props.fetchMap,
          stores = _this$props.stores;

      if (fetchMap) {
        for (var key in fetchMap) {
          if (fetchMap.hasOwnProperty(key)) {
            var shouldFetch = stores[key] && stores[key].shouldFetch;
            var fetch = fetchMap[key] && typeof fetchMap[key] === 'function';

            if (shouldFetch && fetch) {
              var currentRequest = this.requests[key];

              if (currentRequest && currentRequest.abort) {
                currentRequest.abort();
              }

              this.requests[key] = fetchMap[key]();
            }
          }
        }
      }
    }
  }, {
    key: "load",
    value: function load(stores) {
      return Object.keys(stores).reduce(function (acc, type) {
        var store = stores[type]; // if the store passed is null, there's an error somewhere

        if (!store) {
          acc.status = 'error';
          return acc;
        } // shouldFetch is true if any of the stores need to be fetched


        acc.shouldFetch = acc.shouldFetch || store.shouldFetch; // fetched is false until they're all fetched

        acc.fetched = acc.fetched && store.fetched; // fetching is true until they're all false

        acc.fetching = acc.fetching || store.fetching; // if either of the statuses is 'error' or 'not found', we error the whole thing

        if (store.status === 'error' || acc.status === 'error') {
          acc.status = 'error';
        } else if (store.status === 'not found' || acc.status === 'not found') {
          acc.status = 'not found';
        } else if (store.status === 'success') {
          acc.status = 'success';
        } // storing the data directly by the store names


        acc.updatedStores[type] = store.data;
        return acc;
      }, {
        fetched: true,
        fetching: false,
        status: null,
        updatedStores: {},
        shouldFetch: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          extSuccess = _this$props2.extSuccess,
          children = _this$props2.children,
          stores = _this$props2.stores,
          whiteLoading = _this$props2.whiteLoading;

      var _this$memoStores4 = this.memoStores(stores),
          fetched = _this$memoStores4.fetched,
          fetching = _this$memoStores4.fetching,
          status = _this$memoStores4.status,
          updatedStores = _this$memoStores4.updatedStores;

      if (fetching) {
        return _react["default"].createElement(_knotchincWebReactComponents2["default"], {
          white: whiteLoading
        });
      }

      if (fetched && (status === 'error' || !extSuccess || status !== 'success')) {
        return _react["default"].createElement(_knotchincWebReactComponents["default"], {
          fetchError: true
        });
      }

      if (!fetched && !fetching) {
        return null;
      }

      return _react["default"].Children.map(children, function (child) {
        return _react["default"].cloneElement(child, updatedStores);
      });
    }
  }]);

  return StoreSync;
}(_react["default"].Component);

StoreSync.defaultProps = {
  extSuccess: true
};
var _default = StoreSync;
exports["default"] = _default;

//# sourceMappingURL=StoreSync.js.map